export const ROUTES = {
  LANDING: '/landing',
  LOGIN: '/login',
  ONBOARDING: '/onboarding',
  PROFILE: '/profile',
  DASHBOARD: '/dashboard',
  PROJECT: '/project/:id',
  ONBOARDING_KYC: '/onboarding/kyc',
  ONBOARDING_PROJECT: '/onboarding/project',
  ONBOARDING_KYC_RESULT: '/onboarding/kyc/result',
  ONBOARDING_NFT: '/onboarding/nft',
  APPLICATION_IN_REVIEW: '/application-in-review',
  UIPLAYGROUND: '/uiplayground',
  GEO_BLOCK: '/restricted',
};
